import { STATUS_CONFIRMED } from '@whitelabel/helpers/constants';
import { processKeys } from '../../../../helpers/api';
import { xcoverAPI } from '..';
import { IClaimBookingsResponse, IClaimBooking } from '../../../../helpers/types';

export const claimBookingsAPI = xcoverAPI.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerClaimBookings: builder.query<IClaimBookingsResponse, { id: string; locale: string | undefined }>({
      query: ({ id, locale }) => {
        const searchParams = new URLSearchParams({
          language: locale as string,
          status: STATUS_CONFIRMED,
          view: 'claims',
        });
        return `customers/${id}/bookings/?${searchParams}`;
      },
      transformResponse: (response: IClaimBookingsResponse) => processKeys(response),
    }),

    getCustomerClaimBooking: builder.query<
      IClaimBooking,
      { bookingID: string; locale: string | undefined; securityToken: string | null }
    >({
      query: ({ bookingID, locale, securityToken }) => {
        const searchParams = new URLSearchParams({
          language: locale as string,
          status: STATUS_CONFIRMED,
          view: 'claims',
        });
        if (securityToken) {
          searchParams.append('security_token', securityToken);
        }
        return `bookings/${bookingID}/?${searchParams}`;
      },
      transformResponse: (response: IClaimBooking) => processKeys(response),
    }),
  }),
  overrideExisting: false,
});
